import { Row, Col, Grid } from "antd";
import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";

import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const { useBreakpoint } = Grid; 

const Footer = ({ t }: any) => {
  const screens = useBreakpoint(); 

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row gutter={[16, 16]} justify="space-between" style={{ paddingTop: "10px", margin: "0", paddingBottom: "30px" }}>
            
            <Col lg={8} md={8} sm={24} xs={24}>
              <Title>{t("Contact")}</Title>
              <Para dangerouslySetInnerHTML={{ __html: t(`<strong>PT. WAHANA MANDIRI SYDRATAMA</strong>`).replace(/\n/g, '<br/>') }} />
              <Para dangerouslySetInnerHTML={{ __html: t(`Rukan Graha Cempaka Mas Blok E No. 26, \nJl. Letjend. Suprapto, Sumur Batu - Kemayoran,\n Jakarta Pusat 10640`).replace(/\n/g, '<br/>') }} />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {screens.md && <Title style={{ visibility: "hidden" }}>{t("Contact")}</Title>}
              <Para>
                <PhoneOutlined style={{ marginRight: 8 }} />
                {t("+6221 422 8400")}
              </Para>
              <Para>
                <MailOutlined style={{ marginRight: 8 }} />
                {t(`sales@whnmandiri.co.id `)}
              </Para>
              <Para>
                <MailOutlined style={{ marginRight: 8 }} />
                {t(`support@whnmandiri.co.id `)}
              </Para>
              
              <Row justify="start" align="middle" style={{ paddingTop: 0, margin: "0" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <Para style={{ margin: 0 }} dangerouslySetInnerHTML={{ __html: t(`<strong>CONTACT US</strong>`) }} />
                  <SocialLink
                    href="https://api.whatsapp.com/send?phone=6281285897024"
                    src="WhatsApp.png" 
                  />
                </div>
              </Row>
            </Col>

            <Col lg={5} md={5} sm={12} xs={12}>
              <Title>{t("Service Point")}</Title>
              <Para>{t("Bandung")}</Para>
              <Para>{t("Semarang")}</Para>
              <Para>{t("Yogyakarta")}</Para>
              <Para>{t("Surabaya")}</Para>
            </Col>

            <Col lg={3} md={3} sm={12} xs={12}>
              <Title style={{ visibility: "hidden" }}>{t("Service Point")}</Title>
              <Para>{t("Medan")}</Para>
              <Para>{t("Makasar")}</Para>
              <Para>{t("Balikpapan")}</Para>
            </Col>

          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container>
          <Row justify="space-between" align="middle" style={{ margin: "0" }}>
            <NavLink to="/">
              <LogoContainer>
                © 2023 Whnmandiri.co.id
              </LogoContainer>
            </NavLink>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
